import React from 'react';
import { useQuery } from '@apollo/client';
import { GET_SERVICIOS } from '../../../graphql/actions/servicio';
// nodejs library that concatenates classes
import classNames from 'classnames';
// react components for routing our app without refresh
import { withRouter } from 'react-router-dom';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
// @material-ui/icons
// core components
import GridContainer from '../../../components/UI/Grid/GridContainer';
import GridItem from '../../../components/UI/Grid/GridItem';
import Button from '../../../components/UI/CustomButtons/Button';
import Card from '../../../components/UI/Card/Card';
import CardBody from '../../../components/UI/Card/CardBody';
import Spinner from '../../../components/UI/Spinner/Spinner';
import Notification from '../../../components/Notification/Notification';
// img
import img08 from '../../../assets/img/img08.jpg';

import sectionServiciosStyle from '../../../assets/jss/coscef/views/indexSections/sectionServiciosStyle';

const useStyles = makeStyles(sectionServiciosStyle);

const IndexServicios = (props) => {
  const classes = useStyles();

  const {
    loading: loadingServicios,
    error: errorServicios,
    data: dataServicios,
  } = useQuery(GET_SERVICIOS, {
    variables: {
      paginate: {
        numServicios: 3,
        cursor: '',
        sortBy: { field: 'createdAt', order: 'ASC' },
      },
    },
    errorPolicy: 'all',
    fetchPolicy: 'no-cache',
  });

  let showNotification = null;
  let seccionCardsServicio = null;
  let seccionButton = null;

  if (loadingServicios) {
    seccionCardsServicio = (
      <div className={classes.section}>
        <GridContainer justify='center'>
          <GridItem xs={12} sm={8} md={8}>
            <Spinner color='gray' />
          </GridItem>
        </GridContainer>
      </div>
    );
  }

  if (errorServicios) {
    seccionCardsServicio = (
      <div className={classes.section}>
        <GridContainer justify='center'>
          <GridItem xs={12} sm={8} md={8}>
            <h2 className={classes.title + ' ' + classes.textCenter}>
              Error al buscar los servicios en el servidor.
            </h2>
          </GridItem>
        </GridContainer>
      </div>
    );

    showNotification = errorServicios.graphQLErrors.map(
      ({ message, status, code }) => (
        <Notification
          key={code}
          mostrar={errorServicios ? true : false}
          msg={message}
          stt={status}
        />
      )
    );
  }

  if (dataServicios && dataServicios.getServicios) {
    const { getServicios } = dataServicios;
    //console.log(getServicios);
    if (getServicios.servicios.length === 0) {
      seccionCardsServicio = (
        <div className={classes.section}>
          <GridContainer justify='center'>
            <GridItem xs={12} sm={8} md={8}>
              <h2 className={classes.title + ' ' + classes.textCenter}>
                No se encontraron servicios, inténtelo más tarde.
              </h2>
            </GridItem>
          </GridContainer>
        </div>
      );
    } else {
      seccionCardsServicio = (
        <GridContainer>
          {getServicios.servicios.map((servicio) => (
            <GridItem xs={12} sm={4} md={4} key={servicio.node._id}>
              <Card color='dark' key={servicio.node._id}>
                <CardBody color>
                  <h5
                    className={
                      classes.cardCategorySocialWhite + ' ' + classes.textCenter
                    }
                  >
                    <i className='fa fa-cog fa-lg' />
                  </h5>
                  <h4
                    className={
                      classes.cardTitleWhite + ' ' + classes.textCenter
                    }
                  >
                    {servicio.node.titulo}
                  </h4>
                  <br />
                  <p
                    className={
                      classes.cardDescriptionWhite + ' ' + classes.textCenter
                    }
                  >
                    {servicio.node.resumen + ' ...'}
                  </p>
                  <br />
                  <div
                    className={
                      classes.stats + ' ' + classes.justifyContentCenter
                    }
                  >
                    <Button
                      color='white'
                      round
                      onClick={(e) => {
                        e.preventDefault();
                        props.history.push('/servicios');
                      }}
                    >
                      Saber más...
                    </Button>
                  </div>
                </CardBody>
              </Card>
            </GridItem>
          ))}
        </GridContainer>
      );

      seccionButton = (
        <GridContainer className={classes.marginTop10}>
          <GridItem
            md={4}
            sm={4}
            className={classNames(
              classes.mrAuto,
              classes.mlAuto,
              classes.textCenter
            )}
          >
            <Button
              type='submit'
              color='dark'
              round
              onClick={(e) => {
                e.preventDefault();
                props.history.push('/servicios');
              }}
            >
              Leer más
            </Button>
          </GridItem>
        </GridContainer>
      );
    }
  }

  return (
    <div className={classes.section}>
      <div className={classes.container}>
        <div id='servicios'>
          <GridContainer>
            <GridItem
              xs={12}
              sm={12}
              md={12}
              className={classes.mlAuto + ' ' + classes.mrAuto}
            >
              <Card plain blog className={classes.card}>
                <GridContainer>
                  <GridItem xs={12} sm={6} md={6}>
                    <br />
                    <br />
                    <br />
                    <h2 className={classes.title + ' ' + classes.textCenter}>
                      Cartera de Servicios.
                    </h2>
                    <h5
                      className={classes.description + ' ' + classes.textCenter}
                    >
                      Contamos con una abultada cartera de servicios que se
                      adaptan a cualquier entorno de trabajo, garantizando un
                      optimo resultado final.
                    </h5>
                  </GridItem>
                  <GridItem xs={12} sm={4} md={4} className={classes.imgCenter}>
                    <img
                      src={img08}
                      alt='...'
                      className={
                        classes.imgRoundedCircle + ' ' + classes.imgFluid
                      }
                    />
                  </GridItem>
                </GridContainer>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
        <div className={classes.marginTop50}>
          {seccionCardsServicio}
          {seccionButton}
        </div>
      </div>
      {showNotification}
    </div>
  );
};

export default withRouter(IndexServicios);
